import { render } from "./modalLoginVender.vue?vue&type=template&id=27c8a59b&scoped=true"
import script from "./modalLoginVender.vue?vue&type=script&lang=js"
export * from "./modalLoginVender.vue?vue&type=script&lang=js"

import "./modalLoginVender.vue?vue&type=style&index=0&id=27c8a59b&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-27c8a59b"

export default script